import React from 'react';
import './Container.scss';

export type ContainerProps = {
    padding?: 'none' | 'small' | 'small-medium' | 'medium' | 'large' | 'medium large';
    row?: boolean;
    flexRow?: boolean;
    column?: boolean;
    greyed?: boolean;
    center?: boolean;
    bordered?: 'grey';
    height?: 'fill';
} & React.HTMLAttributes<HTMLDivElement>;

export const Container: React.FC<ContainerProps> = ({
    children,
    className,
    padding = 'medium',
    row = false,
    flexRow = false,
    column = false,
    greyed = false,
    center = false,
    bordered,
    height,
    ...props
}) => {
    return (
        <div
            data-padding={padding}
            data-row={row}
            data-flex-row={flexRow}
            data-column={column}
            data-greyed={greyed}
            data-center={center}
            data-bordered={bordered}
            data-height={height}
            className={`container ${className ?? ''}`}
            {...props}
        >
            {children}
        </div>
    );
};
